import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import ReplayIcon from '@material-ui/icons/Replay';
// import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#111',
    height: '100%',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex',
  },
  statsIcon: {
    marginRight: theme.spacing(1),
  },
}));

const PrivateCameraCard = ({
  message = 'Privacy Shutter Closed',
  actionText = 'No access allowed',
  className,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Box display="flex" justifyContent="center" mb={3}>
          <VisibilityOffIcon />
        </Box>
        <Typography
          align="center"
          color="textPrimary"
          gutterBottom
          variant="h4"
        >
          {message}
        </Typography>
        <Typography align="center" color="textPrimary" variant="body1">
          {actionText}
        </Typography>
      </CardContent>
      <Box flexGrow={1} />
      <Divider />
      <Box p={2} onClick={(e) => e.stopPropagation()}>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid className={classes.statsItem} item>
            <AccessTimeIcon className={classes.statsIcon} color="action" />
            <Typography color="textSecondary" display="inline" variant="body2">
              Updated
            </Typography>
          </Grid>
          <Grid className={classes.statsItem} item>
            <ReplayIcon className={classes.statsIcon} color="action" />
            <Typography color="textSecondary" display="inline" variant="body2">
              Retry
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

PrivateCameraCard.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  actionText: PropTypes.string,
};

export default PrivateCameraCard;
